import { handleActions } from 'redux-actions'

import {
  SET_ADDONS,
} from './addons.actions'
import { LOGOUT } from '../../actions'

const initialState = {
  data: [],
  addonsConfig: [],
  addonsConfigValues: [],
}

export default handleActions({
  [SET_ADDONS]: (state, action) => ({
    ...state,
    data: action.payload.addons,
    addonsConfig: action.payload.addonsConfig,
    addonsConfigValues: action.payload.addonsConfigValues,
  }),
  [LOGOUT]: () => initialState,
}, initialState)
